module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1927"
    }
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1977"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c8_r1#d7e1",
      "id": "d6e1"
    }
  }, [_vm._v("1. Carver’s George")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2007"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c9_r1#d7e2",
      "id": "d6e2"
    }
  }, [_vm._v("2. Wandering Years")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2037"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c10_r1#d7e3",
      "id": "d6e3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Road to Tuskegee")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2067"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c11_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Pressures and Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2097"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c12_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. From Power to Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2127"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c13_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Out of the Shadow")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2167"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c14_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Science Shall Make You Free")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2197"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c15_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Simply the Truth")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2227"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c16_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Peanut Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2257"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c17_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. In the Midst of Plenty")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2287"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c18_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Public Figure")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2327"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c19_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Gift of Hope")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e235d7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c20_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2357"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c21_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2387"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c22_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d9t0017"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c23_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2417"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554048_epub_c24_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e77f0f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Perr_9781595554048_epub_c7_r1.vue
// module id = 72
// module chunks = 0